import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Gift, Sparkles } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const features = ['Dashboard profesional del paciente', 'Evaluación antropométrica completa', 'Cálculo automático de IMC', 'Cálculo automático de ICC (Índice Cintura-Cadera)', 'Clasificación OMS automática', 'Peso saludable estimado', 'Calculadora energética (Mifflin-St Jeor)', 'TMB (Tasa Metabólica Basal)', 'GET (Gasto Energético Total)', 'Cálculo automático de déficit, mantenimiento y superávit', 'Calculadora de macronutrientes', 'Distribución automática de proteínas', 'Distribución automática de carbohidratos', 'Distribución automática de grasas', 'Calculadora de hidratación personalizada', 'Ajuste automático según nivel de actividad física', 'Historial antropométrico completo', 'Seguimiento de peso', 'Seguimiento de IMC', 'Seguimiento de cintura', 'Seguimiento de ICC', 'Gráficos automáticos de evolución', 'Semáforos visuales de interpretación', 'Informe profesional imprimible', 'Resumen nutricional automático', 'Guía visual para toma de medidas', 'Guía rápida de interpretación de indicadores', 'Manual de uso paso a paso', 'Sistema listo para usar en consultorio', 'Compatible con Google Sheets', '100% editable y reutilizable para pacientes ilimitados'];
export function ExtraBonus() {
  const [open, setOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    scale: 0.97
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} className="mb-6" data-id="element-84">
      <div className="bg-gradient-to-br from-amber-50 via-yellow-50 to-amber-50 border-2 border-amber-300 rounded-2xl overflow-hidden shadow-lg" data-id="element-85">
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white text-center py-2.5 px-4" data-id="element-86">
          <div className="inline-flex items-center gap-2 font-bold text-sm md:text-base" data-id="element-87">
            <Sparkles className="w-4 h-4" data-id="element-88" />
            BONO EXTRA ESPECIAL · INCLUIDO HOY
            <Sparkles className="w-4 h-4" data-id="element-89" />
          </div>
        </div>

        <button onClick={() => setOpen(!open)} className="w-full px-5 py-4 flex items-center justify-between text-left hover:bg-amber-100/40 transition-colors duration-200" data-id="element-90">
          <div className="flex items-center gap-3 min-w-0" data-id="element-91">
            <div className="bg-amber-500 text-white w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-92">
              <Gift className="w-5 h-5" data-id="element-93" />
            </div>
            <div className="min-w-0" data-id="element-94">
              <div className="text-xs font-bold text-amber-700" data-id="element-95">BONO EXTRA</div>
              <div className="text-base md:text-lg font-bold text-slate-900" data-id="element-96">
                Mini Centro de Evaluación
              </div>
              <div className="text-xs md:text-sm text-slate-600" data-id="element-97">
                Plantilla completamente funcional · +30 funcionalidades
              </div>
            </div>
          </div>
          {open ? <ChevronUp className="w-5 h-5 text-amber-600 flex-shrink-0" data-id="element-98" /> : <ChevronDown className="w-5 h-5 text-amber-600 flex-shrink-0" data-id="element-99" />}
        </button>

        <AnimatePresence data-id="element-100">
          {open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="overflow-hidden" data-id="element-101">
              <div className="px-5 pb-5" data-id="element-102">
                <div className="bg-white rounded-xl p-4 border border-amber-200" data-id="element-103">
                  <p className="text-sm text-slate-700 mb-3 font-medium" data-id="element-104">
                    Una plantilla completamente funcional para:
                  </p>
                  <div className="grid sm:grid-cols-2 gap-x-4 gap-y-1.5" data-id="element-105">
                    {features.map((feature, idx) => <div key={idx} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-106">
                        <span className="text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-107">
                          ✅
                        </span>
                        <span data-id="element-108">{feature}</span>
                      </div>)}
                  </div>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </motion.div>;
}